/**
 * Images/vidéo de PRÉVISUALISATION UNIQUEMENT.
 *
 * Ce fichier pointe vers des photos Unsplash et une vidéo publique libre de
 * droits — le sujet ne correspond pas forcément à CMP Lubumbashi, elles ne
 * servent qu'à voir le rendu du design avec du vrai contenu au lieu de
 * placeholders vides. À remplacer par les vraies photos/vidéos de l'église
 * avant mise en ligne (voir la liste de photos demandées dans docs/PRD.md),
 * en les auto-hébergeant et en les compressant pour tenir l'objectif 3G.
 */
import first_jeunesse from "@/assets/first_jeunes.png";
import first_enfant from "@/assets/first_enfant.jpeg";
import first_maman from "@/assets/first_maman.jpeg";
import first_papa from "@/assets/first_papa.jpeg";

export const HERO_IMAGE_URL =
  "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?w=1600&q=60&fm=jpg&fit=crop";

export const PASTEUR_PORTRAIT_URL =
  "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&q=70&fm=jpg&fit=crop";

export const PREDICATION_THUMBNAIL_URL =
  "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=700&q=60&fm=jpg&fit=crop";

export const HORAIRES_IMAGE_URL =
  "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=700&q=55&fm=jpg&fit=crop";

// Petite mosaïque « qui nous sommes » sur la page Première visite
export const JOIE_IMAGES = [
  {
    src: first_jeunesse,
    alt: "",
  },
  {
    src: first_enfant,
    alt: "",
  },
  {
    src: first_maman,
    alt: "",
  },
  {
    src: first_papa,
    alt: "",
  },
];

// Vidéo de démonstration (Big Buck Bunny, Blender Foundation — licence CC-BY, libre d'usage)
export const PREDICATION_VIDEO_ID = "aqz-KE-bpKQ";
